import { Component, ComponentFactoryResolver, OnInit,ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { AspLoadingService } from 'app/main/auto-spare-parts/asp-loading/asp-loading.service';
import { AspDashboardService } from './asp-dashboard.service';
import { AspOrderListComponent } from '../asp-order-list/asp-order-list.component';
import { AspOrderDetailsComponent } from '../asp-order-details/asp-order-details.component';

@Component({
  selector: 'app-asp-dashboard',
  templateUrl: './asp-dashboard.component.html',
  styleUrls: ['./asp-dashboard.component.scss']
})
export class AspDashboardComponent implements OnInit {
  greeting: string = 'Good morning';
  recentOrdersList: any[] = [];
  requestProgressList: any[] = [];
  garageName: string = '';
  outStandings: number = 0;
  pendingQuoteApprove: number = 0;
  totalDues: number = 0;
  pendingCount: number = 0; 
   totalSavings: number = 0;
  totalSavingsPercentage: any;
  totalPurchasePercentage: any;
  totalPurchase: number = 0;
  totalOrders: number = 0;
  oesPercentage: number = 0;
  orderKey: any;
  month: any;
  selectedBrand: any;
  insurerGarageKey: string;
  insurance: any;
  isInsurance: boolean;
  spareSelectedGarageName: any;
  constructor( private aspLoadingService: AspLoadingService,
    private resolver: ComponentFactoryResolver,
    private aspDashboardService: AspDashboardService,
    private router: Router,
  ) { }
    @ViewChild('orderlistContainer', { read: ViewContainerRef }) container1!: ViewContainerRef;
    @ViewChild('intstantorder', { read: ViewContainerRef }) container!: ViewContainerRef;

  ngOnInit(): void {
    this.spareSelectedGarageName = localStorage.getItem("spareSelectedGarageName");
    this.callGarageMetrics();
     this.setGreeting();
  }
  setGreeting(): void {
    const hour = new Date().getHours(); // 0–23

    if (hour >= 5 && hour < 12) {
      this.greeting = 'Good Morning';
    } else if (hour >= 12 && hour < 17) {
      this.greeting = 'Good Afternoon';
    } else if (hour >= 17 && hour < 21) {
      this.greeting = 'Good Evening';
    } else {
      this.greeting = 'Greetings from Autoverse';
    }
  }
  get hasDashboardData(): boolean {
    return (
      (this.pendingCount ?? 0) > 0 ||
      (this.totalDues ?? 0) > 0 ||
      (this.totalSavings ?? 0) > 0 ||
      (this.totalPurchase ?? 0) > 0 ||
      (this.totalOrders ?? 0) > 0 ||
      (this.oesPercentage ?? 0) > 0 ||
      (this.recentOrdersList?.length ?? 0) > 0 ||
      (this.requestProgressList?.length ?? 0) > 0
    );
  }
   callGarageMetrics() {
    this.aspLoadingService.show();
    const garageKey   = localStorage.getItem('garageKey');
    const userKey     = localStorage.getItem('spareUserKey');
    const filterWith  = '';
     this.aspLoadingService.show();
    this.aspDashboardService
      .getGarageMetrics(garageKey, userKey, filterWith)
      .subscribe(
        (res: any) => {
          
          // console.log('Garage Metrics Response:', res);

          if(res?.code == 200 && res?.data){

            const data = res.data;

            // Snapshot
            this.garageName    = data.garageName;
            this.totalSavings = data.totalSavings;
            this.totalPurchasePercentage = data.totalPurchasePercentage;
            this.totalSavingsPercentage = data.totalSavingsPercentage;
            this.totalPurchase = data.totalPurchase;
            this.totalOrders  = data.totalOrders;
            this.oesPercentage = data.oesPercentage;
            this.outStandings = data.outStandings;
            this.month = data.month;
            // Lists
            this.recentOrdersList = data.recentOrdersList || [];
            this.requestProgressList = data.requestProgressList || [];

            // Todo
            this.pendingQuoteApprove = data?.toDoList?.pendingQuoteApprove || 0;
            this.totalDues = data?.toDoList?.totalDues || 0;
            this.pendingQuoteApprove =  data?.toDoList?.pendingQuoteApprove || 0;
          // header count = same as pending quotes for now
          this.pendingCount = this.pendingQuoteApprove;

          }
          this.aspLoadingService.hide();
        },
        (err) => {
          console.error('Garage Metrics Error:', err);
          this.aspLoadingService.hide();
        }
      );
  }
  getOrderStatusText(status: string): string {

    if (!status) return 'Order placed';

    const s = status.toLowerCase();

    if (s === 'packed') {
      return 'Parts packed';
    }

    // ✅ API gives "On The Way"
    if (s === 'on the way' || s === 'in transit' || s === 'shipped') {
      return 'Parts in transit';
    }

    // ✅ API gives "Confirmed"
    if (s === 'confirmed') {
      return 'Parts confirmed';
    }

    if (s === 'delivered') {
      return 'Parts delivered';
    }

    if (s === 'cancelled') {
      return 'Order cancelled';
    }

    // fallback for unexpected values
    return status;
  }


  // =============status showing in request tab of home page============
  getStatusMessage(statusDetails: { [key: string]: number } | undefined): string {

    if (!statusDetails) return '⏳ Requested';

    if (statusDetails['4'] || statusDetails['10']) {
      return '📦 Order Created';
    } else if (statusDetails['9']) {
      return '✅ Quote Approved';
    } else if (statusDetails['8']) {
      return '💬 Quote Received';
    } else if (statusDetails['1']) {
      return '⏳ Requested';
    } else if (statusDetails['0']) {
      return '❌ Cancelled';
    } else {
      return '⏳ Requested';
    }
  }

  buildStatusDetails(status: number) {
    if (status === undefined || status === null) return undefined;

    return {
      [status.toString()]: 1
    };
  }
  getStatusClass(status: number | undefined): string {
    switch (status) {
      case 4:
      case 10:
        return 'order-created';
      case 9:
        return 'quote-approved';
      case 8:
        return 'quote-received';
      case 1:
        return 'requested';
      case 0:
        return 'cancelled';
      default:
        return 'requested';
    }
  }

  // =================my-request-page-with status===============?
  goToRequestsByStatus(status: number) {
    this.router.navigate(['/my-request'], { queryParams: { status: status } });
  }
  getRequestStatusText(status: number): string {

    if (status === undefined || status === null) {
      return 'Requested';
    }

    switch (status) {

      case 4:
      case 10:
        return 'Order Created';

      case 9:
        return 'Quote Approved';

      case 8:
        return 'Quote Pending Approval';

      case 1:
        return 'Quote Requested';

      case 0:
        return 'Cancelled';

      default:
        return 'Quote Requested';
    }
  }
  // ==========giving space  after, in part names===========
  formatItemNames(itemNames: string): string {
    return itemNames ? itemNames.split(',').join(', ') : '';
  }
      getOrderStatusIcon(status: string): string {
    if (!status) return '';

    const s = status.toLowerCase();

    switch (s) {
      case 'created':
        return '🆕';
      case 'confirmed':
        return '✅';
      case 'packed':
        return '📦';
      case 'on the way':
        return '🚚';
      case 'delivered':
        return '📍';
      default:
        return '';
    }
  }

  getOrderStatusClass(status: string): string {
    if (!status) return '';

    const s = status.toLowerCase();

    switch (s) {
      case 'created':
        return 'created';
      case 'confirmed':
        return 'confirmed';
      case 'packed':
        return 'packed';
      case 'on the way':
        return 'on-the-way';
      case 'delivered':
        return 'delivered';
      default:
        return '';
    }
  }
  onScroll() {
    console.log('Scrolling...');
  }
   loadOrderList() {
    this.container1.clear();
    const factory = this.resolver.resolveComponentFactory(AspOrderListComponent);
    const componentRef = this.container1.createComponent(factory);
    const instance = componentRef.instance as AspOrderListComponent;
    this.router.navigate(['/order-list']);
    instance.ngOnInit();
  }
  
  loadMakePayment(){
  this.router.navigate(['/payment-collection'])
  }
  
  loadorderdetails(orderKey) {
      
      this.orderKey = orderKey;
      const factory = this.resolver.resolveComponentFactory(AspOrderDetailsComponent);
      const componentRef = this.container.createComponent(factory);
  
      // Access the instance and call the method
      const componentBInstance = componentRef.instance as AspOrderDetailsComponent;
      componentBInstance.closeSidebar(true);
      componentBInstance.getOrderDetails(orderKey);
  
    }
    navigateToDetails(id: string) {
    this.router.navigate(
      ['/request-details'],
      { queryParams: { id: id } }
    );
  }
}
